module.exports = __webpack_public_path__ + "static/media/close-simple.e4bd71a2.svg";